/**
 *
 * NVMonitor
 *
 */

import _ from 'lodash'
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { injectIntl } from 'react-intl'
import { SelectorUtils } from '../../Utils'
import message from '../message'

const { selector } = SelectorUtils

const errorCodeToMessage = {
  150000: 'internal_server_error',
  150001: 'not_found',
  150002: 'entity_not_found',
  150003: 'bad_request',
  150004: 'request_timeout',
  150005: 'forbidden',
  150006: 'entity_exists',
  150007: 'token_expired',
  150008: 'unauthorized',
  150009: 'insufficient_permission',
  150010: 'api_error',
  150011: 'too_many_requests'
}

class NVMonitor extends React.Component {
  componentDidUpdate (prevProps) {
    const {
      entity,
      monitor,
      successIndicator = 'success',
      successMessage = 'success',
      successValues = {},
      customErrors = {},
      onSuccess,
      onError,
      intl
    } = this.props
    const data = _.get(entity, `${monitor}.data`)
    const loading = _.get(entity, `${monitor}.loading`)
    const error = _.get(entity, `${monitor}.error`)
    const prevLoading = _.get(prevProps.entity, `${monitor}.loading`)

    if (!loading && prevLoading) {
      if (data && (_.isFunction(successIndicator) ? successIndicator(data) : _.get(data, successIndicator))) {
        message.success(
          intl.formatMessage(
            { id: `types.success.${successMessage}` },
            _.isString(successValues) ? { [successValues]: _.get(data, successValues) } : successValues
          )
        )
        if (_.isFunction(onSuccess)) {
          onSuccess(_.get(data, successIndicator))
        }
      } else if (error) {
        const errorMessage = customErrors[error.code]
        if (errorMessage !== null) {
          message.error(
            intl.formatMessage({
              id: `types.error.${errorMessage || errorCodeToMessage[error.code]}`
            })
          )
        }
        if (_.isFunction(onError)) {
          onError(error)
        }
      }
    }
  }

  render () {
    return null
  }
}

const mapStateToProps = createStructuredSelector({
  entity: selector('entity')()
})

const withConnect = connect(mapStateToProps)

export default compose(injectIntl, withConnect)(NVMonitor)
